import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const EditableRow = ({
  childRef,
  text,
  type,
  placeholder,
  children,
  ...props
}) => {
  const [isEditing, setEditing] = useState(false);
  const handleKeyDown = (event, inputType) => {
    const { key } = event;
    const keys = ['Escape', 'Tab'];
    const enterKey = 'Enter';
    const allKeys = [...keys, enterKey];
    if (enterKey === key) {
      setEditing(false);
    }
    if (
      (inputType === 'input' && keys.indexOf(key) > -1) ||
      (inputType !== 'input' && allKeys.indexOf(key) > -1)
    ) {
      setEditing(false);
    }
  };

  useEffect(() => {
    if (childRef && childRef.current && isEditing === true) {
      childRef.current.focus();
    }
  }, [isEditing, childRef]);

  return (
    <section {...props}>
      {isEditing ? (
        <div
          onBlur={() => setEditing(false)}
          onKeyDown={(e) => handleKeyDown(e, type)}
        >
          {children}
        </div>
      ) : (
        <div
          className={classNames({
            'placeholder-text': placeholder && !text,
          })}
          onClick={() => setEditing(true)}
        >
          <span>{text || placeholder || 'Editable content'}</span>
        </div>
      )}
    </section>
  );
};

EditableRow.propTypes = {
  text: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  children: PropTypes.element.isRequired,
  childRef: PropTypes.any,
};

export default EditableRow;
